import Button from "./button";

// 字体图标
import "./fonts/font.scss";

// 把所有的组件存储起来，数组里可以存储很多的自定义组件，[Button,From,...]
const components = [Button];

// 定义install方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = Vue => {
  // 判断是否安装，如果安装过了就不安装了
  if (install.installed) return;
  install.installed = true;
  // 遍历注册所有组件
  components.map(component => Vue.use(component));
};

// 检测到vue才执行
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

// 对外暴露
export default {
  install,
  // 所有组件，必须具有 install，才能使用 Vue.use()
  ...components
};
